import { Accordion, AccordionSummary, ListItemText, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const Ingredients = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6-content"
                id="panel6-header"
            >
                How to properly write down ingredients?
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    "ingredient" means any substance or product, including flavorings, food
                    additives and food enzymes and any constituent ingredient used in the
                    manufacture or preparation of food and still present in the final product, even
                    if in a modified form; Waste is not considered an "ingredient";
                </Typography>
                <Typography variant="body2">
                    Among the packaging gases, such as carbon dioxide, argon and nitrogen, which do
                    not become part of the consumed product, can be removed from the list of
                    ingredients and can be combined under the following name:
                </Typography>
                <Styled.OrderedList>
                    <Styled.ListItem>
                        <ListItemText primary='"Bottled in a protective atmosphere"' />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary='"Bottling may happen in a protective atmosphere"' />
                    </Styled.ListItem>
                </Styled.OrderedList>
                <Typography className="heading">Notes to consider</Typography>
                <Styled.OrderedList>
                    <Styled.ListItem>
                        <ListItemText primary="The list of ingredients must include all food ingredients, when an ingredient represents 2% or more of the finished product it must be listed in descending order of weight, only then can ingredients that are less than 2% be listed unordered." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Ingredients must be listed by their specific name." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Any processing agent that causes allergies or food intolerances must be indicated in the list of ingredients in bold format." />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText
                            primary="
                            for sparkling wine. Liqueur d'expedition and liqueur tirage must appear in the list of ingredients either alone or together with the listed ingredients that make up said compounds."
                        />
                    </Styled.ListItem>
                </Styled.OrderedList>
                <Typography className="heading">Correct method for listing ingredients</Typography>
                <Typography variant="body2">
                    Grape, concentrated grape must, preservatives and antioxidants{" "}
                    <Styled.Bold>(potassium bisulphite)</Styled.Bold>, Bottled in a protective
                    atmosphere
                </Typography>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default Ingredients;
